import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { PromotionListResType } from "api/promotion/type";
import { ResponseEnum } from "enums/response";
import { NoInfer } from "react-redux";
import { PromotionStateType } from "types/promotion";

import { getListPromotion } from "./promotion.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<PromotionStateType>>
) => {
  builder
    .addCase(getListPromotion.pending, (state: PromotionStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getListPromotion.fulfilled,
      (
        state: PromotionStateType,
        action: PayloadAction<PromotionListResType>
      ) => {
        state.isLoading = false;

        if (action.payload.status !== ResponseEnum.statusSuccess) return;

        state.listPromotion = [...action.payload.data];
      }
    );
};
